import React, { useState, useEffect } from 'react';

const HomeBanner = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Array di immagini per il carosello - solo immagini senza testo
  const images = [
    '/dashboard-photo.jpg',
    '/dashboard-photo.jpg',
    '/dashboard-photo.jpg',
    '/dashboard-photo.jpg'
  ];
  
  // Effetto per far avanzare automaticamente il carosello immagini
  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentImageIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));
    }, 4000); // 4 secondi per ogni immagine
    
    return () => clearInterval(imageInterval);
  }, [images.length]);

  // Funzione per cambiare l'immagine nel carosello
  const changeImage = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="max-w-[1800px] mx-auto overflow-hidden">
      <div className="flex flex-col md:flex-row w-full">
        {/* Sezione con video */}
        <div className="w-full md:w-3/4 relative bg-black h-64 sm:h-80 md:h-96 overflow-hidden">
          {/* Video in background - wrapper esterno */}
          <div className="absolute inset-0 w-full h-full">
            {/* Video HTML5 locale */}
            <video
              className="absolute inset-0 w-full h-full object-cover"
              autoPlay
              muted
              loop
              playsInline
              controls={false}
              preload="auto"
              style={{
                pointerEvents: 'none' // Impedisce interazioni con il video
              }}
            >
              <source src="/dashboard-video.mp4" type="video/mp4" />
              <p className="text-white text-center p-4 text-sm sm:text-base">
                Il tuo browser non supporta i video HTML5.
              </p>
            </video>
          </div>
        </div>
        
        {/* Sezione carosello immagini - solo immagini senza testo */}
        <div className="w-full md:w-1/4 bg-gradient-to-b from-blue-800 to-blue-900 flex flex-col h-32 sm:h-48 md:h-96">
          
          <div className="flex-1 relative overflow-hidden">
            {/* Immagini carosello */}
            {images.map((imageUrl, index) => (
              <div 
                key={index}
                className={`absolute inset-0 transition-opacity duration-1000 ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`}
              >
                <div className="w-full h-full relative">
                  {/* Immagine di sfondo */}
                  <img
                    src={imageUrl}
                    alt={`Immagine ${index + 1}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback se l'immagine non esiste
                      e.target.style.display = 'none';
                      e.target.parentElement.querySelector('.fallback-content').style.display = 'flex';
                    }}
                  />
                  
                  {/* Fallback content se l'immagine non carica */}
                  <div className="fallback-content w-full h-full bg-gradient-to-b from-blue-700 to-blue-900 flex-col justify-center items-center" style={{display: 'none'}}>
                    <div className="text-center">
                      <div className="w-12 h-8 sm:w-16 sm:h-10 md:w-16 md:h-10 mx-auto bg-blue-600 rounded-lg relative shadow-lg">
                        <div className="absolute inset-0 flex items-center justify-center">
                          <span className="text-xs text-blue-200 font-medium">W</span>
                        </div>
                        <div className="absolute -bottom-1 left-2 sm:left-3 w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-300 rounded-full"></div>
                        <div className="absolute -bottom-1 right-2 sm:right-3 w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-300 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            
            {/* Indicatori di posizione */}
            <div className="absolute bottom-2 sm:bottom-4 left-0 right-0 flex justify-center gap-1.5 sm:gap-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => changeImage(index)}
                  className={`w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full transition-all duration-300 ${
                    index === currentImageIndex 
                      ? 'bg-white scale-110 shadow-lg' 
                      : 'bg-white/50 hover:bg-white/70'
                  }`}
                  aria-label={`Vai all'immagine ${index + 1}`}
                />
              ))}
            </div>
            
            {/* Pulsanti di navigazione */}
            <button
              onClick={() => changeImage(currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1)}
              className="absolute left-1 sm:left-2 top-1/2 transform -translate-y-1/2 w-6 h-6 sm:w-8 sm:h-8 bg-black bg-opacity-30 hover:bg-opacity-50 text-white rounded-full flex items-center justify-center transition-all duration-200"
              aria-label="Immagine precedente"
            >
              <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            <button
              onClick={() => changeImage(currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1)}
              className="absolute right-1 sm:right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 sm:w-8 sm:h-8 bg-black bg-opacity-30 hover:bg-opacity-50 text-white rounded-full flex items-center justify-center transition-all duration-200"
              aria-label="Immagine successiva"
            >
              <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner; 